/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React Base Styles
import colors from "assets/theme-dark/base/colors";
import borders from "assets/theme-dark/base/borders";
import typography from "assets/theme-dark/base/typography";

// Material Dashboard 2 PRO React helper functions
import pxToRem from "assets/theme-dark/functions/pxToRem";
import { ESCURO, FONTE } from "assets/coresTema";

const { info, transparent } = colors;
const { borderRadius } = borders;
const { size } = typography;

const inputOutlined = {
  styleOverrides: {
    root: {
      // transparente como o MDInput (o campo usado na maioria das telas)
      backgroundColor: transparent.main,
      fontSize: FONTE.campo,
      borderRadius: borderRadius.md,

      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: ESCURO.bordaForte,
      },

      "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: info.main,
        },
      },

      // campo desabilitado (dado só de leitura): legível no escuro
      "&.Mui-disabled": {
        backgroundColor: ESCURO.painelEscuro,
        "& .MuiInputBase-input, & .MuiSelect-select": {
          color: ESCURO.textoSecundario,
          WebkitTextFillColor: ESCURO.textoSecundario,
        },
      },
    },

    notchedOutline: {
      borderColor: ESCURO.borda,
    },

    input: {
      color: ESCURO.texto,
      // pequeno e normal com a mesma altura (38px), como na maioria das telas
      padding: pxToRem(10),
      backgroundColor: transparent.main,

      "&::placeholder": {
        color: ESCURO.textoFraco,
        opacity: 1,
      },
    },

    inputSizeSmall: {
      fontSize: FONTE.campo,
      padding: pxToRem(10),
    },

    multiline: {
      color: ESCURO.texto,
      padding: 0,
    },
  },
};

export default inputOutlined;
